module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 119
// module chunks = 0 1